<template>
  <div class="guest-picker ph6-l pv3-l tc bs--booking-tool" :class="themeSite">
    <p class="f-smallest fw5 ttu mb3-l">{{ translations.selectGuests }}</p>

    <div class="mb4-l">
      <p class="mb2 o-50 f-smallest">{{ translations.adults }}</p>
      <NumberInput :value="2" @input="onAdultsInput" />
    </div>

    <div class="mb4-l">
      <p class="mb2 o-50 f-smallest">{{ translations.children }}</p>
      <NumberInput :value="0" @input="onChildrenInput" />
    </div>
  </div>
</template>

<script>
import s from "../store"
import NumberInput from "./NumberInput.vue"

export default {
  name: "GuestPicker",

  components: {
    NumberInput
  },

  props: {
    translations: Object,
    themeSite: { type: String }
  },

  methods: {
    onChildrenInput: function(count) {
      s.state.booking.child = count
    },

    onAdultsInput: function(count) {
      s.state.booking.adult = count
    }
  }
}
</script>
